import * as yup from 'yup';
import { minZeroMsg, requiredMsg, typeMsg } from '../../utils/validationMessages';
import { transactionCurrencyIdField } from '../../../../../../../schemas/transactions/TransactionsCommon.schema';
import { transactionDateSchema } from '../../../../../../Finance2/Forms/transactionFieldSchemas';
import { integerField, pricePerShareField } from '../../../../../../../schemas/common-schema-defs';

export function validateRestructureObject(value: unknown, basePath: string, errorMessage: string) {
  if (value == null) {
    return true;
  }

  const errors: yup.ValidationError[] = [];
  Object.entries(value as object).forEach(([key, v]) => {
    if (v == null) {
      errors.push(new yup.ValidationError(errorMessage, [], `${basePath}.${key}`));
    }
  });

  if (errors.length > 0) {
    return new yup.ValidationError(errors);
  }

  return true;
}

export function eqShareExchangeFields() {
  return {
    fundId: yup.number().nullable().required(requiredMsg('Fund')),
    transactionDate: transactionDateSchema(),
    receivedSharesNo: yup
      .number()
      .label('Received Shares')
      .nullable()
      .min(0, minZeroMsg('Received Shares'))
      .when('_viewModel.useSplitByRestructureId', {
        is: (val: boolean | undefined) => val === false,
        then: (schema) =>
          schema.required(requiredMsg('Received Shares')).typeError(typeMsg('Received Shares', 'number')),
      }),
    receivedPricePerShare: pricePerShareField()
      .label('Received PPS')
      .nullable()
      .min(0, minZeroMsg('Received PPS'))
      .when('_viewModel.useSplitByRestructureId', {
        is: (val: boolean | undefined) => val === false,
        then: (schema) =>
          schema.required(requiredMsg('Received PPS')).typeError(typeMsg('Received PPS', 'number')),
      }),
    currencyid: transactionCurrencyIdField(),
    fullyDilutedShares: integerField().nullable().optional(),
    notes: yup
      .string()
      .nullable()
      .optional()
      .transform((_, val) => (val === val ? val : null)),
    security: yup.string().label('Received Security').nullable(),
    _viewModel: yup.object({
      exchangedSharesByRestructureId: yup
        .object()
        .nullable()
        .test((value) => {
          return validateRestructureObject(
            value,
            '_viewModel.exchangedSharesByRestructureId',
            'All securities must have a received PPS value'
          );
        }),
      receivedSharesByRestructureId: yup
        .object()
        .nullable()
        .test((value, context) => {
          if (!context?.parent?.useSplitByRestructureId) {
            return true;
          }

          return validateRestructureObject(
            value,
            '_viewModel.receivedSharesByRestructureId',
            'All securities must have a received shares value'
          );
        }),
      receivedPpsByRestructureId: yup
        .object()
        .nullable()
        .test((value, context) => {
          if (!context?.parent?.useSplitByRestructureId) {
            return true;
          }

          return validateRestructureObject(
            value,
            '_viewModel.receivedPpsByRestructureId',
            'All securities must have a received PPS value'
          );
        }),
    }),
  };
}

export function eqShareExchangeFormSchema() {
  return yup.object(eqShareExchangeFields());
}

export function eqShareExchangeGridSchema() {
  return yup.object(eqShareExchangeFields()).omit(['fullyDilutedShares', '_viewModel']);
}
